import React, { memo } from "react";
import { PerformerTitleWrapper } from "./style";

const KTPerformerTitle = memo(({ name = "" }) => {
  return <PerformerTitleWrapper>{`${name} Tickets`}</PerformerTitleWrapper>;
});

export default KTPerformerTitle;
